import { TextField } from '@automata/ui';
import Autocomplete from '@mui/material/Autocomplete';

import { useValidBatches } from '../../hooks/useValidBatches';

type Props = {
  handleChange: (batches: number | null) => void;
  batches: number | null;
};

const BatchesInput = ({ handleChange, batches }: Props): JSX.Element => {
  const { maxBatches, validBatches } = useValidBatches();
  const validBatchesStrings = validBatches.map(String);

  // autocomplete uses strings for performance reasons
  return (
    <Autocomplete<string>
      options={validBatchesStrings}
      onInputChange={(_, value) => handleChange(Number(value))}
      value={batches ? String(batches) : ''}
      noOptionsText="Invalid batch number for current configuration"
      renderOption={(props, option) => (
        <li {...props} key={option}>
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label={`Batches (MAX ${maxBatches})`} />
      )}
    />
  );
};

export default BatchesInput;
